import DateFormat from '../common/dateFormat/DateFormat';

const INITIAL_STATE = {
	registro: {},
	aguardando: false,
	modoTela: 'lista',
	filtro: {
		data_inicial: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAnterior(30)),
		data_final: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual())
	},
	lista: [],
	listaTipo: [{ id: 1, valor: 'Novo' }, { id: 2, valor: 'Inventário' }],
	listaFornecedor: [],
	listaEmbalagem: [],
	listaEstoqueLocal: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'EMBALAGEM_ENTRADA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'EMBALAGEM_ENTRADA_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

        case 'EMBALAGEM_ENTRADA_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

        case 'EMBALAGEM_ENTRADA_FILTRO':
            return {
				...state,
				filtro: action.payload.filtro
			};

        case 'EMBALAGEM_ENTRADA_FORNECEDOR_SELECT_LISTADO':
			return {
				...state,
				listaFornecedor: action.payload.data
			};

        case 'EMBALAGEM_ENTRADA_EMBALAGEM_SELECT_LISTADO':
			return {
				...state,
				listaEmbalagem: action.payload.data
			};

        case 'EMBALAGEM_ENTRADA_ESTOQUE_LOCAL_SELECT_LISTADO':
			return {
				...state,
				listaEstoqueLocal: action.payload.data
			};

        default:
            return state;
    }
}
